import React from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";

const ContactSection = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        color: "white",
        padding: { xs: "60px 6%", md: "80px 5%" },
        gap: { xs: 6, md: 8 },
        alignItems: "flex-start",
      }}
    >
      {/* LEFT SIDE */}
      <Box
        sx={{
          flex: { xs: "1 1 100%", md: "1 1 50%" },
          paddingRight: { xs: 0, md: "5%" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: { xs: "center", md: "flex-start" },
          textAlign: { xs: "center", md: "left" },
        }}
      >
        <Button
          variant="outlined"
          sx={{
            color: "#d2ad6d",
            borderColor: "#d2ad6d",
            borderRadius: "30px",
            padding: "6px 18px",
            width: "fit-content",
            textTransform: "none",
            mb: 3,
            "&:hover": {
              borderColor: "#c19b58",
            },
          }}
        >
          ● Get in Touch
        </Button>

        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            lineHeight: 1.3,
            mb: 4,
            fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.8rem" },
          }}
        >
          Have A <span style={{ color: "#d2ad6d" }}>Project In Mind?</span>
          <br />
          Let’s Make It Happen
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 4, sm: 8 },
            mt: 3,
            alignItems: { xs: "flex-start", sm: "flex-start" },
          }}
        >
          <Box >
            <Typography variant="subtitle2" sx={{ opacity: 0.7, mb: 1 }}>
              Address
            </Typography>
            <Typography
              variant="body1"
              sx={{ lineHeight: 1.6, fontSize: { xs: "0.9rem", sm: "1rem" } }}
            >
              5609 E Sprague Ave, Spokane <br />
              Valley, WA 99212, USA
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" sx={{ opacity: 0.7, mb: 1 }}>
              Support
            </Typography>
            <Typography
              variant="body1"
              sx={{ lineHeight: 1.6, fontSize: { xs: "0.9rem", sm: "1rem" } }}
            >
              +(084) 456-0789 <br />
              Support@Example.Com
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* RIGHT SIDE */}
      <Box
        sx={{
          flex: { xs: "1 1 100%", md: "1 1 50%" },
          display: "flex",
          flexDirection: "column",
          gap: { xs: 2.5, sm: 3 },
        }}
      >
        {/* Row 1 */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
          }}
        >
          <TextField
            label="Full Name *"
            variant="filled"
            fullWidth
            InputProps={{
              disableUnderline: true,
              sx: {
                backgroundColor: "#1a1613",
                borderRadius: "30px",
                color: "white",
              },
            }}
            InputLabelProps={{ style: { color: "#aaa" } }}
          />

          <TextField
            label="Phone *"
            variant="filled"
            fullWidth
            InputProps={{
              disableUnderline: true,
              sx: {
                backgroundColor: "#1a1613",
                borderRadius: "30px",
                color: "white",
              },
            }}
            InputLabelProps={{ style: { color: "#aaa" } }}
          />
        </Box>

        {/* Row 2 */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
          }}
        >
          <TextField
            label="Email Address *"
            variant="filled"
            fullWidth
            InputProps={{
              disableUnderline: true,
              sx: {
                backgroundColor: "#1a1613",
                borderRadius: "30px",
                color: "white",
              },
            }}
            InputLabelProps={{ style: { color: "#aaa" } }}
          />

          <TextField
            select
            label="Services *"
            variant="filled"
            fullWidth
            InputProps={{
              disableUnderline: true,
              sx: {
                backgroundColor: "#1a1613",
                borderRadius: "30px",
                color: "white",
              },
            }}
            InputLabelProps={{ style: { color: "#aaa" } }}
          >
            <MenuItem value="Web Design">Web Design</MenuItem>
            <MenuItem value="Development">Development</MenuItem>
            <MenuItem value="SEO">SEO</MenuItem>
            <MenuItem value="Branding">Branding</MenuItem>
          </TextField>
        </Box>

        {/* Message */}
        <TextField
          label="Write Message *"
          variant="filled"
          multiline
          rows={5}
          fullWidth
          InputProps={{
            disableUnderline: true,
            sx: {
              backgroundColor: "#1a1613",
              borderRadius: "20px",
              color: "white",
            },
          }}
          InputLabelProps={{ style: { color: "#aaa" } }}
        />

        {/* Button */}
        <Button
          variant="outlined"
          endIcon={<ArrowOutwardIcon />}
          sx={{
            alignSelf: { xs: "center", md: "flex-start" },
            mt: 1,
            borderColor: "#d2ad6d",
            borderRadius: "30px",
            color: "white",
            px: 3,
            py: 1.2,
            textTransform: "none",
            fontWeight: "bold",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#d2ad6d",
              color: "#000",
            },
          }}
        >
          Send Message
        </Button>
      </Box>
    </Box>
  );
};

export default ContactSection;
